/**
 * i18n Configuration
 *
 * Shared configuration for next-intl internationalization.
 * Supports English and Amharic languages.
 */

export const locales = ['en', 'am'] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'en';

export const localeNames: Record<Locale, string> = {
  en: 'English',
  am: 'አማርኛ', // Amharic
};

export const localeFlags: Record<Locale, string> = {
  en: '🇺🇸',
  am: '🇪🇹',
};

// Locale configuration for formatting
export const localeConfigs: Record<Locale, {
  dateFormat: Intl.DateTimeFormatOptions;
  numberFormat: Intl.NumberFormatOptions;
  currency: string;
}> = {
  en: {
    dateFormat: { year: 'numeric', month: 'long', day: 'numeric' },
    numberFormat: { style: 'decimal' },
    currency: 'USD',
  },
  am: {
    dateFormat: { year: 'numeric', month: 'long', day: 'numeric' },
    numberFormat: { style: 'decimal' },
    currency: 'ETB',
  },
};
